// =======================================================================
// 汎用メソッド
// =======================================================================
// ------------------------------
// メディアクエリセットアップメソッド
// デフォルトはmin-width:768で設定してあるので、下記のように使う
// setupMediaQuery((event) => { if(event.matches){ console.log('PC') } else { console.log('SP') } })
// ------------------------------
// ブレイクポイント
const BP = {
  pc: window.matchMedia('(min-width:768px)')
};

export function setupMediaQuery(listener, mql = BP['pc'], initialize = true) {
  // 新しいメディアクエリをセットアップ
  const handleMediaChange = (event) => {
    if (listener) {
      listener(event);
    }
  };

  mql.addEventListener("change", handleMediaChange);

  // 初期化処理を行うかどうかのフラグに基づいて実行
  if (initialize) {
    handleMediaChange(mql);
  }
};


// ------------------------------
// スムーススクロールセットアップメソッド
// ------------------------------
export function setupSmoothScroll(element,settings){
  const scroll = (hash,settings) => {
    const defaultSetting = {
      buffer:0,
      speed:500
    };
    const options = { ...defaultSetting, ...settings };

    $('body, html').stop().animate({
      scrollTop: $(hash).offset().top - options.buffer
    }, options.speed)
  }


  $(element).on('click',function(){
    const href = $(this).attr('href');

    if ((href === '#') || (href === '')) {
      scroll('html',settings);
    } else {
      scroll(href,settings);
    }
  })
}


// ------------------------------
// アコーディオンセットアップメソッド
// ------------------------------
export function setupAccordions(elements,animationSpeed = 400){

  // アコーディオンが存在しない場合
  if(elements.length < 0){
    return false;
  }

  elements.each((i,elem) => {
    const btn = $(elem).find('.js-summary');
    const panel = $(elem).find('.js-detailsContent');
    const type = $(elem).data('type');
    switch(type){
      case 'slide':
        btn.on('click',function(e){
          e.preventDefault();
          if($(elem).attr('open')){
            $(panel).slideUp(animationSpeed,function(){
              $(elem).removeAttr('open');
            });
          }else{
            $(elem).attr('open',true);
            $(panel).hide().slideDown(animationSpeed);
          }
        });
        break;
      case 'fade':
        btn.on('click',function(e){
          e.preventDefault();
          if($(elem).attr('open')){
            $(panel).fadeOut(animationSpeed,function(){
              $(elem).removeAttr('open');
            });
          }else{
            $(elem).attr('open',true);
            $(panel).hide().fadeIn(animationSpeed);
          }
        });
    }
  })
}

// ------------------------------
// タブパネルセットアップメソッド
// ------------------------------
export function setupTabPanel(elements, animationSpeed = 400){
  // タブパネルがない場合終了
  if(elements.length < 0 ){
    return false;
  }
  elements.each((i,tabPanel) => {
    const tabList = $(tabPanel).find('.js-tabList');
    const tabs = tabList.find('button');
    const panel = $(tabPanel).find('[role="tabpanel"]');

    // タブボタン
    tabs.on('click',function(){
      const targetPanel = $(this).attr('aria-controls');

      // タブから現在すべての選択状態を取り除く
      tabs.attr('aria-selected',false);

      // このタブを選択されたタブとして設定
      $(this).attr('aria-selected', true);

      // tabindex切り替え
      tabs.attr('tabindex', -1);
      $(this).attr('tabindex', 0);

      // すべてのタブパネルを非表示に
      panel.hide().attr('hidden', true);

      // 選択されたパネルを表示
      $(`#${targetPanel}`).fadeIn(animationSpeed).attr('hidden',false);
    });

    // タブリストのタブボタン矢印キーフォーカス
    let tabFocus = 0;
    tabList.on('keydown',function(e){
      const enabledTabs = tabList.find('button:not([disabled])');
      if (enabledTabs.length === 0) return;

      // 右に移動
      if (e.keyCode === 39 || e.keyCode === 37) {
        if (enabledTabs.length === 0) return;

        enabledTabs.eq(tabFocus).attr("tabindex", -1);
        if (e.keyCode === 39) {
          tabFocus++;
          // 最後にいる場合は、最初に移動
          if (tabFocus >= enabledTabs.length) {
            tabFocus = 0;
          }
          // 左に移動
        } else if (e.keyCode === 37) {
          tabFocus--;
          // 最初にいる場合は、最後に移動
          if (tabFocus < 0) {
            tabFocus = enabledTabs.length - 1;
          }
        }

        // 無効なタブボタンをスキップ
        while (enabledTabs.eq(tabFocus).is('[disabled]')) {
          if (e.keyCode === 39) {
            tabFocus++;
            if (tabFocus >= enabledTabs.length) {
              tabFocus = 0;
            }
          } else if (e.keyCode === 37) {
            tabFocus--;
            if (tabFocus < 0) {
              tabFocus = enabledTabs.length - 1;
            }
          }
        }

        enabledTabs.eq(tabFocus).attr("tabindex", 0).focus();
      }
    })
  })
}


// =======================================================================
// 以下は読み込み時にセッティングされる
// =======================================================================
// ------------------------------
// スマホでのホバーアクション実装属性追加
// ------------------------------
document.getElementsByTagName('main')[0].setAttribute('ontouchstart', '');


// ------------------------------
// 背景固定
// 読み込み完了後に背景をセット
// ------------------------------
$(window).on('load',function(){
  const bgFixedContents = $('.js-bg-fixed'); //固定背景コンテンツ
  let scrollY = $(window).scrollTop(); //ブラウザのスクロール量
  // 背景固定要素がが存在しない場合終了
  if(bgFixedContents.length < 0){
    return false;
  }

  bgFixedContents.css({'overflow':'clip'})

  bgFixedContents.each((i,elem) => {
    const bg = $(elem).find('.js-bg');

    // コンテンツの情報
    let contentY = $(elem).offset().top;
    let contentHeight = $(elem).height();

    const changeCSSFunc = () => {
      // scroll量がコンテンツ以上かつコンテンツ未満
      if (contentY < scrollY) {
        bg.css('top', scrollY - contentY)
      } else {
        bg.css('top', 0)
      }
    }

    // 初期化
    changeCSSFunc();

    $(window).on(
      {
        'scroll':function(){scrollY = $(window).scrollTop(); changeCSSFunc()},
        'resize':function(){contentY = $(elem).offset().top; contentHeight = $(elem).height(); changeCSSFunc()},
      }
    );

    $('summary').on('click',function(){
      contentY = $(elem).offset().top; contentHeight = $(elem).height();
      changeCSSFunc();
    });
  });
});
